<template>
  <credit-form></credit-form>
</template>

<script>
import creditForm from '@/components/credit/form'

export default {
  components: {
    creditForm
  }
}
</script>